// extracted by mini-css-extract-plugin
export default {"select-pill-wrapper":"Channel_select-pill-wrapper__QAoEF","arrow-right-icon":"Channel_arrow-right-icon__xugzF"};